import { Preset } from '@/components/form-components/ListModal'
import { CheckboxRadioField } from '@/modules/templates/types/blueprint'

export const radioPresets: Preset<CheckboxRadioField[]>[] = [
  {
    name: 'Yes - No',
    config: [
      { label: 'Yes', desiredState: true },
      { label: 'No', desiredState: false },
    ],
  },
  {
    name: 'True - False',
    config: [
      { label: 'True', desiredState: true },
      { label: 'False', desiredState: false },
    ],
  },
  {
    name: 'Yes - No - N/A',
    config: [
      { label: 'Yes', desiredState: true },
      { label: 'No', desiredState: false },
      { label: 'N/A', desiredState: null },
    ],
  },
  {
    name: 'COVID-19',
    config: [
      { label: 'Double dose', desiredState: true },
      { label: 'Single dose', desiredState: null },
      { label: 'None', desiredState: false },
    ],
  },
]
